import { __extends } from "tslib";
import Resource from './resource';
var AnalyticsModule = (function (_super) {
    __extends(AnalyticsModule, _super);
    function AnalyticsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnalyticsModule.prototype.trackEvent = function (data) {
        return this.client.http.post('/events', data);
    };
    AnalyticsModule.prototype.createAttribution = function (data) {
        return this.client.http.post('/events/attribution', data);
    };
    return AnalyticsModule;
}(Resource));
export default AnalyticsModule;
//# sourceMappingURL=analytics.js.map